// The API base URL is NOT defined here — it comes from environment.serverUrl
// (src/environments/*), which is what the HTTP interceptor actually prepends.
// The apiDev/apiStage/apiProd constants that used to sit here were never imported
// and had drifted into a contradictory second source of truth; removed in CD-3557.

export const URLs = {
    prod: 'https://coindepo.com/token',
    dev: 'https://dev.coindepo.io/token',
    stage: 'https://stage.coindepo.io/token'
};